import React from 'react';
import cn from 'classnames';
import { IconComponentType } from '@creditflowresearch/uilib/Icon';
import type { InputSize } from './types';
import styles from './input.module.scss';

interface IProps {
  prependComponent?: React.ReactElement | React.ElementType | React.FC<any>,
  isCustomIconVisible?: boolean,
  icon?: IconComponentType,
  iconClassName?: string,
  size?: InputSize,
}

const InputPrepend = ({
  prependComponent: PrependComponent,
  isCustomIconVisible,
  icon: Icon,
  iconClassName,
  size,
}: IProps) => {
  return (
    <div className={ cn(styles.prependComponent, size && styles[`size${ size }`]) }>
      { /* eslint-disable-next-line no-nested-ternary */ }
      { PrependComponent ? (
        React.isValidElement(PrependComponent) ? (
          PrependComponent
        ) : (
          // @ts-ignore
          <PrependComponent />
        )
      ) : (
        <>
          { isCustomIconVisible && (
            <div className={ cn(styles.iconPositionLeft, size && styles[`size${ size }`]) }>
              <Icon className={ iconClassName } />
            </div>
          ) }
        </>
      ) }
    </div>
  );
};

export default React.memo(InputPrepend);
